









import { defineComponent } from '@vue/composition-api';

import { WDialog } from '@/components/base/dialog';
export default defineComponent({
  name: 'FooterDialogWrapper',
  components: { WDialog },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  emits: ['close'],
  setup(props, { emit }) {
    const closedHandler = () => {
      emit('close');
    };

    return {
      closedHandler,
    };
  },
});
